export const introLength = 700;
export const placementLength = 1000;
export const huntLength = 500;
export const tradeLength = 1000;
export const testimonialLength = 300;
export const totalLength =
  introLength + placementLength + huntLength + tradeLength + testimonialLength;
